import { render, staticRenderFns } from "./RoomColorContainer.vue?vue&type=template&id=592bb48a"
import script from "./RoomColorContainer.vue?vue&type=script&lang=js"
export * from "./RoomColorContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports